import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_SCAN_QR_CODE: GlameraIconDefinition = {
  name: 'scan-qr-code',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-scan-qr-code-group">
      <path class="glm-scan-qr-code-bit glm-scan-qr-code-bit-0" d="M17 12v4a1 1 0 0 1-1 1h-4"></path>
      <path class="glm-scan-qr-code-bit glm-scan-qr-code-bit-1" d="M17 3h2a2 2 0 0 1 2 2v2"></path>
      <path class="glm-scan-qr-code-bit glm-scan-qr-code-bit-2" d="M17 8V7"></path>
      <path class="glm-scan-qr-code-bit glm-scan-qr-code-bit-3" d="M21 17v2a2 2 0 0 1-2 2h-2"></path>
      <path class="glm-scan-qr-code-bit glm-scan-qr-code-bit-4" d="M3 7V5a2 2 0 0 1 2-2h2"></path>
      <path class="glm-scan-qr-code-bit glm-scan-qr-code-bit-5" d="M7 17h.01"></path>
      <path class="glm-scan-qr-code-bit glm-scan-qr-code-bit-6" d="M7 21H5a2 2 0 0 1-2-2v-2"></path>
      <rect class="glm-scan-qr-code-core" x="7" y="7" width="5" height="5" rx="1" ry="1"></rect>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-scan-qr-code-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './scan-qr-code.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ScanQrCodeIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_SCAN_QR_CODE;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
